module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-47.3bab179b.png";